import { combineReducers } from 'redux';

import userInterfaceStore from '@store/user-interface';

const rootReducer = combineReducers({
  userInterface: userInterfaceStore.reducer,
});

export type TRootState = ReturnType<typeof rootReducer>;

export default rootReducer;
